function applyFormat() {
  const elements = document.querySelectorAll(
    "h1, h4, p[role='heading']"
  );

  elements.forEach((el) => {
    if (el.classList.contains("formatted")) return;

    const text = el.textContent.trim();

    // | または ｜ を含まないものはスキップ
    if (!/[|｜]/.test(text)) return;

    const parts = text.split(/\s*[|｜]\s*/);
    if (parts.length < 2) return;

    el.innerHTML = `
      <span class="title-prefix">${parts[0]}</span>
      <span class="title-main">${parts.slice(1).join(" | ")}</span>
    `;

    el.classList.add("formatted");
  });
}

// 初回
window.addEventListener("load", function () {
  setTimeout(applyFormat, 500);
  setTimeout(applyFormat, 1500);
});

// Shopify再描画対応
document.addEventListener("shopify:section:load", applyFormat);